import React from 'react'
import styled from 'styled-components'
import { SearchInput } from '../Common/CommonStyle'

import {
  HomeNavWrapper,
  Icon,
  ViewSelectionButton,
  NudistaMedium7,
  NudistaSemiBold13,
  RobotoMedium14,
  NudistaBold14,
  NudistaMedium9,
  RowFlexDiv,
  SearchFlexDiv,
  SInput,
  ColumnFlexDiv,
  P,
} from '../Common/CommonStyle'

const AssignmentsTab = ({ assignments }) => {
  return (
    <RowFlexDiv
      width='70%'
      alignSelf='flex-start'
      flexFlow='row wrap'
      justifyContent='flex-start'
      // backgroundColor='#123456'
    >
      {assignments.length > 0
        ? assignments?.map((value) => (
            <AssignmentFLexDiv width='32%' marginTop='2%'>
              <Icon
                width='100%'
                height='100%'
                src='/images/mainView/assignmentsView/stock_home.jpg'
              />
              <Imagetag />

              <RowFlexDiv position='absolute' marginTop='1%' marginLeft='1%'>
                <Icon
                  src='/images//mainView/assignmentsView/tag.svg'
                  alt='facebook_icon'
                />
              </RowFlexDiv>

              <SearchFlexDiv
                width='100%'
                height='31px'
                backgroundColor='#FFFFFF'
                borderRadius='4px'
              >
                <SInput
                  paddingLeft='10px'
                  width='100%'
                  height='100%'
                  placeholder={'Add Caption'}
                />
                <RowFlexDiv
                  width='30px'
                  height='20px'
                  backgroundColor='#FFFFFF'
                  justifyContent='center'
                >
                  <Icon src='/images/mainView/assignmentsView/arrow-dropdown_2.png' />
                </RowFlexDiv>
              </SearchFlexDiv>
            </AssignmentFLexDiv>
          ))
        : null}
    </RowFlexDiv>
  )
}

const Imagetag = () => {
  return (
    <RowFlexDiv
      width='8%'
      marginTop='4px'
      position='absolute'
      alignSelf='flex-end'
      height='16.5px'
      gap='5%'
      backgroundColor='#6a26ca'
      justifyContent='center'
      borderRadius='4px'
    >
      <Icon src='/images/mainView/assignmentsView/textarea-t.svg' alt='map' />
      <Icon src='/images/mainView/assignmentsView/rotate-180.svg' alt='map' />
      <Icon src='/images/mainView/assignmentsView/mark.svg' alt='map' />
      <Icon src='/images/mainView/assignmentsView/tag.svg' alt='map' />
      <Icon src='/images/mainView/assignmentsView/share.svg' alt='map' />
    </RowFlexDiv>
  )
}

export const AssignmentFLexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-overflow: ellipsis;
  border: 4px solid white;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  :hover {
    border-color: #fb8f02;
  }
  background-color: ${(props) => props.backgroundColor};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`

export default AssignmentsTab
